export interface NotificationSetting {
  id: string;
  notification_key: string;
  category: 'customer_appointment' | 'customer_followup' | 'staff' | string;
  label: string;
  description: string;
  enabled: boolean;
  sms_enabled: boolean;
  email_enabled: boolean;
  timing_offset_minutes?: number;
  applicable_roles: string[];
  extra_config?: Record<string, any>;
}

export interface NotificationReminder {
  id: string;
  setting_id: string;
  offset_minutes: number;
  sms_enabled: boolean;
  email_enabled: boolean;
}

export interface NotificationTemplate {
  id: string;
  template_key: string;
  label: string;
  subject?: string;
  body: string;
  type?: 'sms' | 'email';
}

export const NOTIFICATION_CATEGORIES = [
  { id: 'customer_appointment', label: 'Customer Appointments', icon: 'calendar' },
  { id: 'customer_followup', label: 'Customer Follow-Up', icon: 'heart' },
  { id: 'staff', label: 'Staff Notifications', icon: 'users' },
];

export const STAFF_ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'manager', label: 'Manager' },
  { value: 'staff', label: 'Staff / Providers' },
  { value: 'selected', label: 'Selected' },
];

export const REMINDER_TIMING_OPTIONS = [
  { value: 60, label: '1 hour before' },
  { value: 120, label: '2 hours before' },
  { value: 180, label: '3 hours before' },
  { value: 240, label: '4 hours before' },
  { value: 720, label: '12 hours before' },
  { value: 1440, label: '24 hours (1 day) before' },
  { value: 2880, label: '2 days before' },
  { value: 4320, label: '3 days before' },
  { value: 10080, label: '1 week before' },
];
